import {hosService} from '../../lib/service/hos'
import {hosOrderCache} from '../../lib/cache/hosOrder'
/**
 *
 * 转诊申请页面的混合文件
 *
 * */
export const initMixin = {
    methods:{
        // 取消申请
        async cancleMixin(context){
            const succ = await hosService.cancleApply({
                id:this.orderId,
                refuseReason:context
            })
            if(succ){
                this.$message({
                    message: '取消成功',
                    type: 'success'
                });
                this.$router.back();
            }
        },
        //确定上传
        async loadUpMixin(){
           let from = this.$refs['disease'].getAttrList();
           const {code,obj} =  await hosService.loadAtt({
                id:this.orderId,
                ...from
            })
            if(code == "0"){
                this.$message({
                    message: '补充资料提交成功。',
                    type: 'success'
                });
                this.setDetail(obj);
            }
        },
        //再次申请
        applyAgainMixin(){
            let type = this.$route.params.type;
            //把详情页面的数据放入缓存
            hosOrderCache.set(this.detailObj);
            //跳转回申请界面
            this.$router.push({path:`/main/referral/hos/${type}/apply`,query:{
                again:true
            }})
        },
        //发起方查询列表
        async queryInitList(form){
         const {list,page}  =  await hosService.initList(form);
         return {list,page}
        }
    }
}